// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
function useQuantity(valueOpt, product, selectedVariant) {
  var value = valueOpt !== undefined ? valueOpt : 1;
  var match = React.useState(function () {
    return value;
  });
  var _setQuantity = match[1];
  var setQuantity = function (fn) {
    if (product === undefined) {
      return Curry._1(_setQuantity, fn);
    }
    var variant = Belt_Option.getWithDefault(selectedVariant, product.firstVariant);
    Curry._1(_setQuantity, function (value) {
      var partial_arg = variant.inventory > 1 ? variant.inventory : 1;
      return Belt_Option.map(Curry._1(fn, value), function (param) {
        return Math.min(partial_arg, param);
      });
    });
  };
  React.useEffect(function () {
    setQuantity(function (param) {
      return value;
    });
  }, [Belt_Option.map(product, function (p) {
    return p.id;
  }), value]);
  React.useEffect(function () {
    if (selectedVariant !== undefined) {
      setQuantity(function (currentQuantity) {
        return Belt_Option.map(currentQuantity, function (currentQuantity) {
          if (currentQuantity > selectedVariant.inventory) {
            return 1;
          } else {
            return currentQuantity;
          }
        });
      });
    }
  }, [Belt_Option.map(selectedVariant, function (v) {
    return v.id;
  })]);
  return [match[0], setQuantity];
}
export { useQuantity };
/* react Not a pure module */